import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/certmanage/list', qs.stringify(params))
}

export const getlistSimp = (params) => {
  return axios.post(root + '/set/certmanage/listSimp', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/certmanage/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/set/certmanage/detail', {params: params})
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root+'/set/certmanage/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/certmanage/save', qs.stringify(params))
  }
}



// WEBPACK FOOTER //
// ./src/api/set/certmanage.js